"use client";

import { Label, Input, Button } from "@oreme/ui";
import React, { type ReactElement } from "react";

function AnalyseForm(): ReactElement {
  return (
    <form
      action=""
      className="relative z-10 flex flex-col gap-3 min-w-96 p-4 bg-background rounded-xl border border-border shadow-lg drop-shadow-lg"
    >
      <Label>Que cherchez-vous ?</Label>
      <div className="flex flex-row gap-2">
        <Input placeholder="Tapez une recherche" value="" />
        <Button>Lancer</Button>
      </div>
    </form>
  );
}

export { AnalyseForm };
